/**
 * Build a vehicles list API route with a safely encoded query term.
 * Unencoded "#" truncates the URL (fragment), dropping embed=… and whitescreening the list.
 */
export function buildVehicleSearchRoute(queryKey, term, extraQuery, embed) {
	return `vehicles?q[${queryKey}]=${encodeURIComponent(term)}${extraQuery}&embed=${embed}`;
}

/** stock_vsearch helper used by vsearch / report / mobile / vin-scanner paths. */
export function buildVehicleVsearchRoute(searchTerm, soldQuery, embed) {
	return buildVehicleSearchRoute('stock_vsearch', searchTerm, soldQuery, embed);
}
